import { Blocks, BrainCircuit, Gem } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/istituti/Eyebrow";

const STEPS = [
  { id: "costruisci", Icon: Blocks, title: "Costruisci", text: "Crea il tuo CV moderno in modo totalmente gratuito attraverso un'interfaccia di nuova generazione." },
  {
    id: "mappatura",
    Icon: BrainCircuit,
    title: "Mappatura AI",
    text: "Affronta il Test Psico-attitudinale. L'AI produrrà un'analisi profonda e un Grafico a Radar. Puoi scegliere di integrare questa analisi nel tuo CV, oppure tenerla privata.",
  },
  {
    id: "pool",
    Icon: Gem,
    title: "Pool Premium",
    text: "Una volta completata l'analisi, hai il controllo: usa il CV gratuitamente, oppure scegli di entrare nel Pool Premium. Se entri, sarai tu a decidere se mantenere il tuo profilo totalmente anonimo oppure no.",
  },
];

export const InfrastrutturaCandidati = () => (
  <section className="relative px-6 py-20 lg:py-36" data-testid="candidati-infrastruttura-section">
    <div className="max-w-7xl mx-auto">
      <Reveal variant="tech" className="mb-14 lg:mb-24">
        <Eyebrow className="mb-6">Come funziona</Eyebrow>
        <h2 className="font-extrabold tracking-[-0.04em] leading-[1] text-4xl sm:text-5xl lg:text-6xl">L'Infrastruttura</h2>
        <span className="tech-line mt-8" />
      </Reveal>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {STEPS.map(({ id, Icon, title, text }, i) => (
          <Reveal key={id} variant="tech" delay={i * 160} className="h-full">
            <article className="why-card glass glass-light h-full rounded-[28px] p-8 sm:p-10 flex flex-col min-h-[400px]" data-testid={`step-card-${id}`}>
              <div className="flex items-center justify-between">
                <span className="h-12 w-12 rounded-2xl border border-[#1e2024] flex items-center justify-center">
                  <Icon className="h-5 w-5 text-cyan" strokeWidth={1.5} style={{ filter: "drop-shadow(0 0 6px rgba(0,229,255,0.6))" }} />
                </span>
                <span className="text-5xl font-extrabold tracking-[-0.05em] text-white/[0.07]">0{i + 1}</span>
              </div>
              <h3 className="pt-16 font-bold tracking-[-0.03em] text-2xl sm:text-[1.7rem]">{title}</h3>
              <p className="mt-4 text-base leading-relaxed text-titanium">{text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
